// components/Layout.tsx
import { Outlet } from "react-router-dom";
import SidebarMenu from "./components/SideBarMenu";
import Header from "./components/Header";

const Layout = () => {
	return (
		<>
			<div className="flex">
				<div className="m-0 p-0 hidden lg:block">

					<SidebarMenu />
				</div>
				{/* <main className="flex-1   border-t-2 border-l-2  rounded-tl-xl  pt-4 pb-2 px-4 bg-gray-100 "> */}
				<main className="w-full">
					<Header />
					<div className="flex-1    pt-4 pb-2 md:px-4 mx-1 md:mx-0  ">
						<Outlet />
					</div>

					{/* <Footer /> */}
				</main>
			</div>
		</>
	);
};

export default Layout;
